import { useParams } from 'react-router-dom';

import DashboardComparison from 'features/dashboard/DashboardComparison';
import useDashboardData from 'pages/dashboard/useDashboardData';

const DashboardComparisonPage = () => {
  const { projectId, otherProjectId } = useParams();

  return <DashboardComparison data={[useDashboardData(projectId), useDashboardData(otherProjectId)]} />;
};

export default DashboardComparisonPage;
